import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Cabinet} from '../models/cabinet';

@Injectable()
export class CabinetService {

  constructor(private httpClient: HttpClient) {
  }

  getCabinets(): Observable<Cabinet[]> {
    return this.httpClient.get<Cabinet[]>(environment.baseUrlWs + '/api/cabinets');
  }

}
